export default __webpack_public_path__ + "static/media/email.05d853e7.svg";